import { Button, Upload, message } from "antd";
import { YhBox, } from "@/components/YhBox";
import { getProdBaseRequestUrl, getBaseUploadData, getToken } from "@/utils/constants";
import type { UploadProps } from "antd";
import { uploadDataModel } from "./uploadDataModel";
import { UploadDataTable } from "./UploadDataTable";
import { InvoiceMate } from "./InvoiceMate";
import { Detail } from "./Detail";
import { useDetailModel } from "../detailModel";

let uploadSize = 0;
export const UploadDataBox = () => {

    const { dataSource, onSearchInvoiceNums, setInvoiceMateVisible } = uploadDataModel();
    const { customer, identification } = useDetailModel();

    const mate = () => {
        let flag = 0;
        dataSource.forEach(data => {
            if (data.purchaserName.trim() !== customer.name?.trim()) {
                flag++;
                message.error("发票号码:" + data.invoiceNum + ",客户名称不一致!");
            }
        });
        if (flag === 0) {
            setInvoiceMateVisible(true);
        }
    }

    let uploadDone = 0;
    let md5List: string[] = [];
    const props: UploadProps = {
        name: 'file',
        multiple: true,
        showUploadList: false,
        action: getProdBaseRequestUrl() + '/fsrv/upload_file?Authorization=' + getToken(),
        data: getBaseUploadData(),
        beforeUpload(file, fileList) {
            uploadSize = fileList.length;
            uploadDone = 0;
            md5List = [];
        },
        onChange(info) {
            if (info.file.status === 'done') {
                uploadDone++;
                md5List.push(info.file.response.retData);
            }
            else if (info.file.status === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
            if (uploadDone === uploadSize && md5List.length > 0) {
                //发票识别、上传
                identification(md5List, false, () => { onSearchInvoiceNums() });
            }
        },
    };

    const action = (
        <>
            <div>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={mate}
                >发票匹配</Button>
                <Upload {...props}>
                    <Button type="link" shape="round" >上传发票</Button>
                </Upload>
            </div>
        </>
    );

    return (
        <>
            <YhBox title={action} >
                <UploadDataTable />
            </YhBox>
            <InvoiceMate />
            <Detail />
        </>
    )
}
